import React from 'react'
import { Dropdown } from '@leshen/ui'
import SeoCtaBar from '../components/SeoCtaBar'
import { StaticImage } from 'gatsby-plugin-image'
import { graphql, navigate, withPrefix } from 'gatsby'
import { Layout, Head as HeadComponent } from '@leshen/gatsby-theme-sylex'
import PhoneCTA from '@leshen/gatsby-theme-leshen/src/components/PhoneCTA'
import { getStateFAQ, getStateFAQSchema } from '../data/state'
import { createPageData } from '../utils/page'
import { faqsToSchema, faqToItem } from '../utils/faq'
import siteTheme from 'gatsby-theme-dish/theme'
import styled from '@emotion/styled'
import footer from '../components/Footer'
import header from '../components/Header'
import { metadata } from '../data/metadata'

import {
  Main,
  Accordion,
  Brandy,
  Column,
  Columns,
  Header,
  Footer,
  LinkButton,
  PackageCard,
  SplitContent,
  Stack,
  Typography,
  VariableContent,
  useMapi,
} from '@leshen/gatsby-theme-leshen'

// import createImage from '../utils/createImage'
// import Midatlantic from '../images/area-hero-images/midatlantic.webp'
// import MidatlanticMobile from '../images/area-hero-images/midatlantic-mobile.webp'
// import Midwest from '../images/area-hero-images/midwest.webp'
// import MidwestMobile from '../images/area-hero-images/midwest-mobile.webp'
// import Northeast from '../images/area-hero-images/northeast.webp'
// import NortheastMobile from '../images/area-hero-images/northeast-mobile.webp'
// import Northwest from '../images/area-hero-images/northwest.webp'
// import NorthwestMobile from '../images/area-hero-images/northwest-mobile.webp'
// import Southeast from '../images/area-hero-images/southeast.webp'
// import SoutheastMobile from '../images/area-hero-images/southeast-mobile.webp'
// import Southwest from '../images/area-hero-images/southwest.webp'
// import SouthwestMobile from '../images/area-hero-images/southwest-mobile.webp'
// import Tropical from '../images/area-hero-images/tropical.webp'
// import TropicalMobile from '../images/area-hero-images/tropical-mobile.webp'
// import West from '../images/area-hero-images/west.webp'
// import WestMobile from '../images/area-hero-images/west-mobile.webp'

export function Head({ data }) {
  const node = data.pageInfo.edges[0].node
  return (
    <>
      <HeadComponent
        pageContext={{ page: createPageData(node) }}
        data={{ site: { siteMetadata: metadata } }}
      />
      <script type="application/ld+json">
        {faqsToSchema([
          getStateFAQSchema(node.FAQ_1, node.State),
          getStateFAQSchema(node.FAQ_2, node.State),
          getStateFAQSchema(node.FAQ_3, node.State),
          getStateFAQSchema(node.FAQ_4, node.State),
          getStateFAQSchema(node.FAQ_5, node.State),
        ])}
      </script>
    </>
  )
}

function State({ data }) {
  const { rotatedNumber } = useMapi()
  const node = data.pageInfo.edges[0].node
  const {
    // Region,
    State,
    FAQ_1,
    FAQ_2,
    FAQ_3,
    FAQ_4,
    FAQ_5,
    _2_Heading,
    _3_Heading,
    _4_Heading,
    _5_Heading,
    _2_Copy_1,
    _3_Copy_1,
    _3_Copy_2,
    _4_Copy_1,
    _4_Copy_2,
    _5_Copy_1,
    Customer_Service,
  } = node

  const customerServiceSection = Customer_Service.toLowerCase() === 'yes'

  // THIS COMMENTED CODE MAY BE NEEDED IN SEPTEMBER 2025 IF THE OFFER EXPIRES
  // LEAVING IT HERE SO WE DON'T HAVE TO REVERSE ENGINEER THEY DYNAMIC IMAGES
  // AGAIN IF THEY NEED TO BE PUT BACK

  // let RegionImage
  // let MobileRegionImage
  // let RegionAlt

  // switch (Region) {
  //   case 'Mid Atlantic':
  //     RegionImage = createImage([Midatlantic])
  //     MobileRegionImage = createImage([MidatlanticMobile])
  //     RegionAlt = 'Midatlantic Region'
  //     break
  //   case 'Mid West':
  //     RegionImage = createImage([Midwest])
  //     MobileRegionImage = createImage([MidwestMobile])
  //     RegionAlt = 'Midwest Region'
  //     break
  //   case 'North East':
  //     RegionImage = createImage([Northeast])
  //     MobileRegionImage = createImage([NortheastMobile])
  //     RegionAlt = 'Northeast Region'
  //     break
  //   case 'North West':
  //     RegionImage = createImage([Northwest])
  //     MobileRegionImage = createImage([NorthwestMobile])
  //     RegionAlt = 'Northwest Region'
  //     break
  //   case 'South East':
  //     RegionImage = createImage([Southeast])
  //     MobileRegionImage = createImage([SoutheastMobile])
  //     RegionAlt = 'Southeast Region'
  //     break
  //   case 'South West':
  //     RegionImage = createImage([Southwest])
  //     MobileRegionImage = createImage([SouthwestMobile])
  //     RegionAlt = 'Southwest Region'
  //     break
  //   case 'Tropical':
  //     RegionImage = createImage([Tropical])
  //     MobileRegionImage = createImage([TropicalMobile])
  //     RegionAlt = 'Tropical Region'
  //     break
  //   default:
  //     RegionImage = createImage([West])
  //     MobileRegionImage = createImage([WestMobile])
  //     RegionAlt = 'West Region'
  //     break
  // }

  const cityDropdownData = data.cities.edges.map((current) => ({
    label: current.node.City,
    value: current.node.Page_Path,
  }))

  return (
    <Layout
      page={createPageData(node)}
      siteMetadata={metadata}
      header={<Header {...header()} />}
      footer={<Footer {...footer()} />}
      main={
        <Main>
          <SplitContent
            backgroundColor="midgray"
            mobileAlignImageToBottom
            variant="split"
            image={
              <StaticImage
                loading="eager"
                src="../images/availability/three-months-free.webp"
                alt="family on couch watching television"
                placeholder="blurred"
              />
            }
            mobileImage={
              <StaticImage
                loading="eager"
                src="../images/availability/three-months-free.webp"
                alt="family on couch watching television"
                placeholder="blurred"
              />
            }
            mainContent={
              <>
                <Typography variant="h1">
                  DISH Network Packages In {State}
                </Typography>
                <Typography variant="body">
                  Watch all your favorite TV shows, plus you get SHOWTIME
                  <sup>®</sup> & DISH MoviePack™ for 3 months at no extra
                  cost.
                </Typography>
                <PhoneCTA color="primary">Get DISH today! Call</PhoneCTA>
                <Brandy text={data.disclaimerOne.text} variant="legal" />
              </>
            }
          />

          {/* ORIGINAL HERO WITH DYNAMIC REGIONAL IMAGES THAT MAY STILL BE NEEDED IN SEPTEMBER 2025 */}
          {/* <Billboard
          backgroundColor="midgray"
          variant="split"
          image={
            <Image
              isImageCritical
              data={RegionImage}
              alt={RegionAlt}
              placeholder="blurred"
            />
          }
          mobileImage={
            <Image
              isImageCritical
              data={MobileRegionImage}
              alt={RegionAlt}
              placeholder="blurred"
              style={{ display: 'block' }}
            />
          }
          mainContent={
            <>
              <Typography variant="h1">
                DISH Network Packages In {State}
              </Typography>
              <Typography variant="body">
                Watch all your favorite TV shows, plus you get SHOWTIME
                <sup>®</sup> & DISH MoviePack™ for 3 months at no extra cost.
              </Typography>
              <PhoneCTA color="primary">Get DISH today! Call</PhoneCTA>
              <Brandy text={data.disclaimerOne.text} variant="legal" />
            </>
          }
        /> */}

          <SeoCtaBar />

          <VariableContent
            style={{ backgroundColor: siteTheme.colors.light }}
            mainContent={
              <>
                <Typography variant="h2">
                  DISH Network Packages in {State}
                </Typography>
                <Typography variant="body">
                  Enjoy a vast selection of high-definition channels with a
                  satellite TV package from DISH in your area. With free
                  standard professional installation in up to six rooms and an
                  included Smart HD DVR, DISH is the perfect choice to enhance
                  your home entertainment.
                </Typography>
              </>
            }
          >
            <Stack spacing="xxl">
              <Columns>
                {data?.allBrandyPackage?.edges?.map(({ node }) => (
                  <PackageCard
                    key={node.brandy_id}
                    packageData={node}
                    content={<PhoneCTA color="primary">Call</PhoneCTA>}
                  />
                ))}
              </Columns>
              <Brandy
                text={data.disclaimerTwo.text}
                variant="legal"
                style={{
                  textAlign: 'center',
                }}
              />
              <Brandy
                text={data.disclaimerThree.text}
                variant="legal"
                style={{
                  textAlign: 'center',
                  margin: 'auto',
                }}
              />
            </Stack>
          </VariableContent>

          {_2_Heading ? (
            <SplitContent
              image={
                <StaticImage
                  src="../images/lifestyle/football-on-tv.webp"
                  alt="Family laughing at show together"
                  placeholder="blurred"
                />
              }
              mainContent={
                <>
                  <Typography variant="h2">{_2_Heading}</Typography>
                  <Typography variant="h5">
                    It’s time to root for your favorite teams in front of your
                    favorite big screen with DISH TV in {State}.
                  </Typography>
                  <Typography variant="body">{_2_Copy_1}</Typography>
                  <PhoneCTA color="primary">Call</PhoneCTA>
                </>
              }
            />
          ) : (
            <SplitContent
              image={
                <StaticImage
                  src="../images/lifestyle/football-on-tv.webp"
                  alt="Family laughing at show together"
                  placeholder="blurred"
                />
              }
              mainContent={
                <>
                  <Typography variant="h2">
                    DISH Network: Where {State} Sports Live
                  </Typography>
                  <Typography variant="h5">
                    It’s time to root for your favorite teams in front of your
                    favorite big screen with DISH TV in {State}.
                  </Typography>
                  <Typography variant="body">
                    From global events like the World Cup to local games from
                    your college sports teams, DISH Network in {State} has all
                    the hard-hitting athletic action you’ve been looking for.
                    The Multi-Sport Pack features 35 major networks that cover
                    football, baseball, basketball, hockey, and soccer, so you
                    can see every touchdown, goal, and home run live from your
                    living room.
                  </Typography>
                  <PhoneCTA color="primary">Call</PhoneCTA>
                </>
              }
            />
          )}

          {_3_Heading ? (
            <SplitContent
              backgroundColor="light"
              image={
                <StaticImage
                  src="../images/lifestyle/family-on-couch-2.webp"
                  alt="Family watching tv"
                  placeholder="blurred"
                />
              }
              mainContent={
                <>
                  <Typography variant="h2">{_3_Heading}</Typography>
                  <Typography variant="h5">
                    Keep it in the neighborhood and get access to local channels
                    with DISH TV.
                  </Typography>
                  <Typography variant="body">{_3_Copy_1}</Typography>
                  <Typography variant="body">{_3_Copy_2}</Typography>
                </>
              }
            />
          ) : (
            <SplitContent
              backgroundColor="light"
              image={
                <StaticImage
                  src="../images/lifestyle/family-on-couch-2.webp"
                  alt="Family watching tv"
                  placeholder="blurred"
                />
              }
              mainContent={
                <>
                  <Typography variant="h2">
                    Local Channels With DISH TV
                  </Typography>
                  <Typography variant="h5">
                    Keep it in the neighborhood and get access to local channels
                    with DISH TV.
                  </Typography>
                  <Typography variant="body">
                    From local news to sports and everything in between, DISH
                    Network is home to what’s happening in your community.
                  </Typography>
                </>
              }
            />
          )}

          <VariableContent
            backgroundColor="midgray"
            mainContent={
              <>
                <Typography variant="h2">
                  Why Get DISH Network Near Me?
                </Typography>
              </>
            }
          >
            <Stack>
              <Columns cardStyled className="center-text info-cards">
                <Column
                  style={{ paddingTop: '20px' }}
                  image={
                    <StaticImage
                      src="../images/icons/bill.svg"
                      alt=""
                      placeholder="blurred"
                    />
                  }
                >
                  <Typography className="center-text" variant="h4">
                    <strong>2-year TV price guarantee</strong>
                  </Typography>
                  <Typography className="center-text" variant="body">
                    The only provider that guarantees your monthly TV price for
                    three years
                  </Typography>
                </Column>
                <Column
                  style={{ paddingTop: '20px' }}
                  image={
                    <StaticImage
                      src="../images/icons/map-pin.svg"
                      alt=""
                      placeholder="blurred"
                    />
                  }
                >
                  <Typography className="center-text" variant="h4">
                    <strong>Local channels for no extra cost</strong>
                  </Typography>
                  <Typography className="center-text" variant="body">
                    Stay in the know with local news and sports
                  </Typography>
                </Column>
                <Column
                  style={{ paddingTop: '20px' }}
                  image={
                    <StaticImage
                      src="../images/icons/shield.svg"
                      alt=""
                      placeholder="blurred"
                    />
                  }
                >
                  <Typography className="center-text" variant="h4">
                    <strong>Signal Reliability Guarantee</strong>
                  </Typography>
                  <Typography className="center-text" variant="body">
                    A reliable signal or your money back.<sup>1</sup>
                  </Typography>
                </Column>
              </Columns>
            </Stack>
          </VariableContent>

          {_4_Heading ? (
            <SplitContent
              backgroundColor="light"
              image={
                <StaticImage
                  src="../images/lifestyle/hughesnet-logo.webp"
                  alt="Devices"
                  placeholder="blurred"
                />
              }
              mainContent={
                <>
                  <Typography variant="h2">
                    DISH Network and Internet Packages in Your Area
                  </Typography>
                  <Typography variant="h5">
                    Looking for TV and internet you can rely on?
                  </Typography>
                  <Typography variant="body">{_4_Copy_1}</Typography>
                  <Typography variant="body">{_4_Copy_2}</Typography>
                  <LinkButton
                    to="https://www.usdish.com/bundles"
                    target="_blank"
                    color="primary"
                  >
                    Explore Bundles
                  </LinkButton>
                  <Typography variant="legal">
                    Subject to availability. Restrictions apply. Internet not
                    provided by DISH and billed separately
                  </Typography>
                </>
              }
            />
          ) : (
            <SplitContent
              backgroundColor="light"
              image={
                <StaticImage
                  src="../images/lifestyle/hughesnet-logo.webp"
                  alt="Devices"
                  placeholder="blurred"
                />
              }
              mainContent={
                <>
                  <Typography variant="h2">
                    TV & Internet With DISH Network in {State}
                  </Typography>
                  <Typography variant="h5">
                    Looking for TV and internet you can rely on?
                  </Typography>
                  <Typography variant="body">
                    Combine TV with internet packages from Hughesnet and
                    Frontier, our partners in creating the ultimate home
                    services experience. Hughesnet offers satellite internet for
                    those in rural areas, while Frontier offers high-speed
                    DSL/fiber internet in select areas. Plus, when you order,
                    you&#39;re eligible for deals and savings from both
                    providers. Call today to order DISH TV and internet
                    together.
                  </Typography>
                  <LinkButton
                    to="https://www.dish.com/availability/rural?kbid=87178&clreqid=b9f0c15e-19b6-4d9e-afe9-9b2317a536fb"
                    target="_blank"
                    color="primary"
                  >
                    Learn More
                  </LinkButton>
                  <Typography variant="legal">
                    Subject to availability. Restrictions apply. Internet not
                    provided by DISH and billed separately
                  </Typography>
                </>
              }
            />
          )}

          <SplitContent
            image={
              <StaticImage
                src="../images/lifestyle/tailgater.webp"
                alt="tailgater"
                placeholder="blurred"
              />
            }
            mainContent={
              <>
                <Typography variant="h2">Take DISH On The Open Road</Typography>
                <Typography variant="body">
                  DISH offers portable satellites for tailgaters and campers who
                  don’t want to leave their favorite programs behind. Portable
                  satellites let you enjoy the great outdoors while never
                  missing a field goal or plot twist.
                </Typography>
                <LinkButton
                  to="https://www.usdish.com/equipment/tailgater"
                  target="_blank"
                  color="primary"
                >
                  Learn More
                </LinkButton>
              </>
            }
          />

          {customerServiceSection && (
            <VariableContent
              backgroundColor="light"
              mainContent={
                <>
                  <Typography variant="h2">
                    DISH Network Customer Service and Support in {State}
                  </Typography>
                  <Typography variant="body">
                    Whether you’re an existing customer seeking service or
                    support or a new customer ready to get signed up, you’ve
                    come to the right place. Our team can help you with anything
                    from paying your bill to scheduling your new service
                    installation. Or, get connected to DISH’s service team for
                    technical support.
                  </Typography>
                </>
              }
            >
              <Stack>
                <Columns className="center-text info-cards">
                  <Column
                    style={{ paddingTop: '20px' }}
                    backgroundColor="light"
                    image={
                      <StaticImage
                        src="../images/icons/cart.svg"
                        alt=""
                        placeholder="blurred"
                      />
                    }
                  >
                    <Typography className="center-text" variant="h4">
                      Get New Dish Network Service
                    </Typography>
                    <Typography className="center-text" variant="body">
                      Ready to experience satellite TV or add high-speed
                      internet? Call to schedule your installation today.
                    </Typography>
                    <LinkButton
                      to={`tel:${rotatedNumber}`}
                      color="primary"
                      style={{ margin: 'auto' }}
                    >
                      Get Started with DISH
                    </LinkButton>
                  </Column>
                  <Column
                    style={{ paddingTop: '20px' }}
                    backgroundColor="light"
                    image={
                      <StaticImage
                        src="../images/icons/identity-protection.svg"
                        alt=""
                        placeholder="blurred"
                      />
                    }
                  >
                    <Typography className="center-text" variant="h4">
                      Pay Your Dish Network Bill
                    </Typography>
                    <Typography className="center-text" variant="body">
                      See{' '}
                      <a
                        href="https://support.dish.com/billing/ways-to-pay"
                        target="_blank"
                        rel="noreferrer"
                      >
                        how to pay your bill online
                      </a>{' '}
                      or on the MyDISH App, by text, phone, or mail. Or speak to
                      a representative for help.
                    </Typography>

                    <>
                      <LinkButton
                        to="https://support.dish.com/billing/ways-to-pay"
                        color="primary"
                        style={{ margin: 'auto' }}
                      >
                        Get Bill Pay Help
                      </LinkButton>
                    </>
                  </Column>{' '}
                  <Column
                    style={{ paddingTop: '20px' }}
                    backgroundColor="light"
                    image={
                      <StaticImage
                        src="../images/icons/conversation.svg"
                        alt=""
                        placeholder="blurred"
                      />
                    }
                  >
                    <Typography className="center-text" variant="h4">
                      Contact DISH Network Customer Service
                    </Typography>
                    <Typography className="center-text" variant="body">
                      Having trouble with your DISH TV service? Contact our
                      customer support team today for all your service needs.
                    </Typography>
                    <LinkButton
                      to={'tel:1-800-333-3474'}
                      color="primary"
                      style={{ margin: 'auto' }}
                    >
                      Contact Customer Support
                    </LinkButton>
                  </Column>
                </Columns>
              </Stack>
            </VariableContent>
          )}

          {_5_Heading ? (
            <SplitContent
              image={
                <StaticImage
                  src="../images/lifestyle/woman-tv-red-couch.webp"
                  alt="Devices"
                  placeholder="blurred"
                />
              }
              mainContent={
                <>
                  <Typography variant="h2">{_5_Heading}</Typography>
                  <Typography variant="body">{_5_Copy_1}</Typography>
                </>
              }
              // ensures background colors alternate consistenly based on which sections are rendering on the page;
              // it looks confusing, I know, but trust me, it works
              {...(!customerServiceSection && { backgroundColor: 'light' })}
            />
          ) : null}

          <VariableContent
            // ensures background colors alternate consistenly based on which sections are rendering on the page
            // it looks confusing, I know, but trust me, it works
            backgroundColor={
              customerServiceSection || (!customerServiceSection && !_5_Heading)
                ? 'light'
                : ''
            }
            mainContent={
              <>
                <Typography variant="h2">
                  Looking for DISH in {State}?
                </Typography>
                <Dropdown
                  options={cityDropdownData}
                  onChange={(e) => navigate(e.value)}
                  placeholderText="Select City"
                  aoa=""
                />
                {cityDropdownData?.map((current) => (
                  <StyledLink
                    href={withPrefix(current.value)}
                    key={current.value}
                  >
                    {current.label}
                  </StyledLink>
                ))}
              </>
            }
          />

          <VariableContent
            backgroundColor={
              !customerServiceSection && _5_Heading ? 'light' : ''
            }
          >
            <Typography variant="h2">Frequently Asked Questions</Typography>
            <Accordion
              items={[
                faqToItem(getStateFAQ(FAQ_1, State)),
                faqToItem(getStateFAQ(FAQ_2, State)),
                faqToItem(getStateFAQ(FAQ_3, State)),
                faqToItem(getStateFAQ(FAQ_4, State)),
                faqToItem(getStateFAQ(FAQ_5, State)),
              ]}
            />{' '}
          </VariableContent>
        </Main>
      }
    />
  )
}

const StyledLink = styled.a`
  display: none !important;
`
export default State

export const query = graphql`
  query StatePageQuery($pagePath: String, $stateAbbreviation: String) {
    allBrandyPackage(
      sort: { name: ASC }
      filter: {
        brandy_id: {
          in: ["dn-americastop120", "dn-americastop200", "dn-americastop250"]
        }
      }
    ) {
      edges {
        node {
          brandy_id
          bullets {
            text
          }
          price {
            amount
            duration
          }
          brand_token
          name
          id
        }
      }
    }
    pageInfo: allDatasetManagerDishAoa(
      filter: { Page_Path: { eq: $pagePath } }
    ) {
      edges {
        node {
          City
          FAQ_1
          FAQ_2
          FAQ_3
          FAQ_4
          FAQ_5
          Page_Path
          State
          Region
          Meta_Description
          Meta_Title
          Promo_Code
          _2_Heading
          _3_Heading
          _4_Heading
          _5_Heading
          _2_Copy_1
          _3_Copy_1
          _3_Copy_2
          _4_Copy_1
          _4_Copy_2
          _5_Copy_1
          Customer_Service
        }
      }
    }
    cities: allDatasetManagerDishAoa(
      filter: { State: { eq: $stateAbbreviation }, Area_Type: { eq: "city" } }
    ) {
      edges {
        node {
          City
          Page_Path
        }
      }
    }
    disclaimerOne: brandyDisclaimer(
      brandy_id: { eq: "disclaimer-premium-short" }
    ) {
      id
      text
    }
    disclaimerTwo: brandyDisclaimer(brandy_id: { eq: "disclaimer-dnfooter1" }) {
      id
      text
    }
    disclaimerThree: brandyDisclaimer(
      brandy_id: { eq: "disclaimer-googleasst" }
    ) {
      brandy_id
      text
    }
  }
`
